import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useAppContext } from '../../../../../redux/slices/appContext'
import { useRedtailFamilyContext } from '../../../../../api/redtail'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import presets from './presets'

export default function useRedtailMetricPreset (presetKey, config = {}) {
  const { clientId, userId } = useAppContext()
  const familyContext = useRedtailFamilyContext(clientId)

  const preset = presets[presetKey]

  const metricQuery = useQuery({
    queryKey: [QUERY_KEYS.redtailDomainQuery, 'metric-preset', userId, clientId, presetKey],
    queryFn: async () => {
      const rawData = await preset.fetchData(familyContext.members, clientId)
      return preset.compute(rawData)
    },
    enabled: !!preset && familyContext.linked === true && !!familyContext.members?.length
  })

  const merged = useMemo(() => {
    if (!preset) return { title: 'Unknown Preset', label: '', icon: null, format: '0' }
    return {
      title: config.title ?? preset.defaults.title,
      label: config.label ?? preset.defaults.label,
      icon: config.icon ?? preset.defaults.icon,
      format: config.format ?? preset.defaults.format
    }
  }, [preset, config.title, config.label, config.icon, config.format])

  return {
    value: metricQuery.data ?? null,
    isLoading: familyContext.isLoading || metricQuery.isFetching,
    notLinked: familyContext.linked === false,
    error: familyContext.error || metricQuery.error,
    ...merged
  }
}
